import { BoundTextAreaField, Css, Icon, Palette } from "@homebound/beam";
import { useMaterialSuperDrawerContext } from "./material-super-drawer/MaterialSuperDrawerContext";

export function MaterialDesignNotesTab() {
  const { formState, readOnly } = useMaterialSuperDrawerContext();
  return <BoundTextAreaField field={formState.designNote} label="Design Notes" readOnly={readOnly} fullWidth />;
}

// Display a red dot if the design notes are not empty in the tab header
export function MaterialDesignNotesTabIndicator() {
  const { formState } = useMaterialSuperDrawerContext();
  if (!formState.designNote.value) return undefined;
  return <Icon icon="circle" inc={1.1} xss={Css.mb2.$} color={Palette.Red500} />;
}
